import { FC } from "react";
import cx from "classnames";
import Paper from "@mui/material/Paper";
import styles from "./MobileModal.module.scss";

const MobileModal: FC<{ className?: string }> = ({ children, ...props }) => {
  return (
    <Paper elevation={0} className={cx(styles.root, props.className)}>
      {children}
    </Paper>
  );
};

export default MobileModal;
